import * as DashboardActions from './../actions/dashboard_actions';
import * as UserActions from './../actions/user_actions';
import extend from 'lodash/extend';


export var Dashboard = (state = {

    DashboardData: null,
    Notifications: null,
    ActiveFacilty: null,

}, action) => {
    switch (action.type) {
        // // Uncomment below block only if you want to persist store data
        case 'persist/REHYDRATE': {
            if (action.payload.Dashboard) {
                action.payload.Dashboard.IsLoggingIn = false;
            } else {
                return state;
            }
        }

        case DashboardActions.DASHBOARD_DATA:
            {
                return extend({}, state, { DashboardData: action.data });
            }
        break;
        case DashboardActions.DASHBOARD_DETAILS_FAIL:
            {
                return extend({}, state, { DashboardData: action.data });
            }
        break;
        case DashboardActions.NOTIFICATIONS_DATA:
            {
                let notificationData = action.data
                notificationData.reverse();
                return extend({}, state, { Notifications: notificationData });
            }
        break;
        case DashboardActions.NOTIFICATIONS_FAIL:
            {
                return extend({}, state, { Notifications: action.data });
            }
            break;
            case DashboardActions.ACTIVE_FACILITY:
                {
                    return extend({}, state, { ActiveFacilty: action.data });
                }
                break;

            case UserActions.USER_LOG_OUT: {

                return extend({}, state, {
                  DashboardData: null,
                  Notifications: null,
                  ActiveFacilty: null
                })
            }
                break;



        default:
            return state;
    }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/dashboard_reducer.js
 **/